export default "#define GLSLIFY 1\n#include <logdepthbuf_pars_fragment>\n\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( 0.0 );\n}";